<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "BooleanSelect",
    props: ["value"],
    data() {
      return {
        data: "",
        list: [{
            name: "是",
            value: 1
          },
          {
            name: "否",
            value: 0
          }
        ]
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.data = value;
        }
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
